import React, { useEffect, useState } from "react";
import "./projects.css";
import Projectbox from "./Projectbox.js";
import { fetchProjects } from "../api/portfolio";
import { defaultProjects } from "../constants/const";

const Projects = () => {
  const [projects, setProjects] = useState(defaultProjects);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    fetchProjects()
      .then((data) => {
        if (!cancelled) {
          setProjects({
            personal: data.personal || [],
            academic: data.academic || [],
          });
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const renderProjects = (list) =>
    list.map((project, index) => (
      <Projectbox
        key={index}
        title={project.title}
        pic={project.pic}
        text={project.text}
        url={project.url}
        link={project.link}
      />
    ));

  if (loading) {
    return (
      <div className="projects-body">
        <p className="content-status">Loading projects…</p>
      </div>
    );
  }

  return (
    <div className="projects-body">
      <div className="projects-content">
        <section className="projects-section">
          <h3 className="section-header">
            <i className="fas fa-code-branch"></i>
            Personal Projects
          </h3>
          <div className="projects-grid">
            {renderProjects(projects.personal)}
          </div>
        </section>

        <section className="projects-section">
          <h3 className="section-header">
            <i className="fas fa-graduation-cap"></i>
            Academic Projects
          </h3>
          <div className="projects-grid">
            {renderProjects(projects.academic)}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Projects;
